/* this file is transformed by vux-loader */
/* eslint-disable */
export default {
  more: 'More',
  ask_doctor: 'Ask doctor',
  fzkf: 'Revisit prescription',
  twzx: 'Graphic consultation',
  spzx: 'Video consultation',
  goodat: 'Expertized in',
  wzl: 'Inquiry volume',
  online: 'Online',
  offline: 'Offline',
  hfl: 'Response rate',
  cfw: 'Services',
  gfans: 'Fans',
  main_intro: 'Introduction',
  go_appointment: 'Make an appt.',
  tjyf: 'Add gravida',
  title: 'Title',
  main_title: 'Main title',
  nav: 'Navigation',
  nickname: 'Nickname',
  yrz: 'Authenticated',
  wsm: 'Unauthenticated',
  fn_title: 'Function tilte',
  test_name: 'Chen Miao',
  test_post_name: 'Physician',
  test_advantageDesc: 'Here is a placeholder for copywriting',
  test_hospital: "People's Hospital",
  test_dept: 'Room 1, Ward Area 1, Nephrology Dept.'
};